import { daysOfWeek } from 'constants/daysOfWeek';

export const getDayString = (date) => {
  const day = new Date(date).getDay();

  return daysOfWeek[day];
};
